import React, { useEffect } from "react";
import "./PerformanceTrend.scss";
import { getPartnerTierListSagaAction } from "../../../../../../../redux/saga/partner-program/saga-actions";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux";
import TrendChart from "./TrendChart";

const PerformanceTrend: React.FC<{ readOnly?: boolean }> = ({
  readOnly: _readOnly = false,
}) => {
  const { partnerTierList } = useAppSelector((state) => state.partner_program);
  const { partnerDetails } = useAppSelector((state) => state.partner_details);
  const dispatch = useAppDispatch();

  const partnerId = partnerDetails?.ID || 0;

  useEffect(() => {
    // Fetch tier list if not already loaded
    if (partnerTierList.length === 0) {
      dispatch(getPartnerTierListSagaAction(0));
    }
  }, [dispatch, partnerTierList.length]);

  return (
    <div className="performance-trend-container">
      <div className="charts-grid">
        {/* Tier Status Over Time - Y-axis: tier names */}
        <TrendChart
          chartKey="tierStatus"
          title="Tier Status Over Time"
          partnerId={partnerId}
          yAxisConfig={{ type: "tierNames", tierList: partnerTierList }}
          yAxisLabel="Tier"
        />

        {/* Total Points Over Time - Y-axis: dynamic */}
        <TrendChart
          chartKey="totalPoints"
          title="Total Points Over Time"
          partnerId={partnerId}
          yAxisConfig={{ type: "dynamic" }}
          yAxisLabel="Points"
        />

        {/* Net New Licenses Purchases - Y-axis: dynamic */}
        <TrendChart
          chartKey="netNewLicenses"
          title="New Licenses Purchases"
          partnerId={partnerId}
          yAxisConfig={{ type: "dynamic" }}
          yAxisLabel="Licenses"
        />

        {/* Total Licenses Over Time - Y-axis: dynamic */}
        <TrendChart
          chartKey="totalLicenses"
          title="Total Licenses Over Time"
          partnerId={partnerId}
          yAxisConfig={{ type: "dynamic" }}
          yAxisLabel="Licenses"
        />
      </div>
    </div>
  );
};

export default PerformanceTrend;
